import * as React from "react";
import { SVGProps } from "react";
const SvgShell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29 27.998H3a1 1 0 1 1 0-2h26a1 1 0 0 1 0 2ZM12.999 14h6v-2h-6v2Zm-6.243.243-1.414-1.414 2.828-2.83-2.828-2.827 1.414-1.415 2.828 2.829L10.999 10l-4.243 4.243ZM3 3a1 1 0 0 0-1 1v18.999a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-19a1 1 0 0 0-1-1H3V3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgShell;
